(function ($) {
    $(document).ready(function () {
        const $variation = $('.single_variation');
        if ($variation.length) {
            $variation.on('show_variation', function () {
                $('p.price').html($('.single_variation_wrap .woocommerce-variation-price .price').html());
            });
        }
        $('div.woocommerce').on('click', 'input.qty', function () {

            $("[name='update_cart']").trigger("click");

        });
    });
})(jQuery);
